import { Option, some, none } from "@danwang/option";

const mapObject = <T, Value>(
  array: T[],
  mapper: (t: T) => [string, Value]
): { [key: string]: Value } => {
  const result: { [key: string]: Value } = {};
  array.forEach((t: T) => {
    const [key, value] = mapper(t);
    result[key] = value;
  });
  return result;
};

const range = (a: number, b?: number) => {
  const start = b === undefined ? 0 : a;
  const end = b === undefined ? a : b;
  const length = Math.abs(end - start);
  const sign = length / (end - start);
  return Array(length)
    .fill(undefined)
    .map((_, i) => start + sign * i);
};

const grouped = <T>(array: T[], count: number): T[][] => {
  const result: T[][] = [];
  array.forEach((el: T) => {
    if (result.length === 0 || result[result.length - 1].length === count) {
      result.push([el]);
    } else {
      result[result.length - 1].push(el);
    }
  });
  return result;
};

const allOptionArray = <T>(array: Option<T>[]): Option<T[]> => {
  const nones = array.filter((v) => v.isEmpty);
  if (nones.length > 0) {
    return none;
  } else {
    return some(array.map((o) => o.get()));
  }
};

export const groupBy = <T>(
  arr: T[],
  grouper: (t: T) => string
): [string, T[]][] => {
  const groups = new Map<string, T[]>();
  arr.forEach((t) => {
    const key = grouper(t);
    const existing = groups.get(key);
    if (existing) {
      existing.push(t);
    } else {
      groups.set(key, [t]);
    }
  });
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return Array.from(groups.entries()) as any;
};

export default {
  range,
  mapObject,
  grouped,
  allOptionArray,
  groupBy,
};
